<button
  type="button"
  class="flex items-center justify-center cursor-pointer p-3 w-full rounded-lg border border-transparent bg-transparent text-surface-600 hover:bg-surface-50 hover:text-surface-900 hover:border-surface-100 transition-colors duration-150"
  (click)="themePanel.toggle($event)"
  pTooltip="Appearance"
  tooltipPosition="right"
  aria-label="Appearance"
>
  <i class="pi pi-palette text-xl! leading-normal!"></i>
</button>

<p-popover #themePanel>
  <div class="flex flex-col gap-3 w-64">
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-surface-500">
        Theme
      </span>
      @for (preset of presets; track preset.id) {
        <button
          type="button"
          class="flex items-start gap-2 text-left p-2 rounded-md border transition-colors duration-150 cursor-pointer"
          [class]="
            preset.id === presetId()
              ? 'bg-primary-50 border-primary-200'
              : 'bg-transparent border-transparent hover:bg-surface-100'
          "
          (click)="selectPreset(preset.id)"
        >
          <i
            class="pi text-sm mt-0.5"
            [class]="preset.id === presetId() ? 'pi-check text-primary' : 'pi-circle text-surface-400'"
          ></i>
          <span class="flex flex-col">
            <span class="text-sm font-medium text-surface-900">{{ preset.label }}</span>
            <span class="text-xs text-surface-500">{{ preset.description }}</span>
          </span>
        </button>
      }
    </div>

    <hr class="border-t border-0 border-surface-200 m-0" />

    <div class="flex items-center justify-between gap-2">
      <span class="flex flex-col">
        <span class="text-sm font-medium text-surface-900">Dark mode</span>
        @if (!activePreset().supportsDark) {
          <span class="text-xs text-surface-500">
            Not available on {{ activePreset().label }}
          </span>
        }
      </span>
      <p-toggleswitch
        [ngModel]="darkMode()"
        (ngModelChange)="setDarkMode($event)"
        [disabled]="!activePreset().supportsDark"
        ariaLabel="Dark mode"
      />
    </div>
  </div>
</p-popover>
